import Clone from './Clone';

export default Clone;
